import { render, staticRenderFns } from "./WorkcentersEdit.vue?vue&type=template&id=5715dd1a&scoped=true&"
import script from "./WorkcentersEdit.vue?vue&type=script&lang=js&"
export * from "./WorkcentersEdit.vue?vue&type=script&lang=js&"
import style0 from "./WorkcentersEdit.vue?vue&type=style&index=0&id=5715dd1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5715dd1a",
  null
  
)

export default component.exports